import { SbBlokData } from "@storyblok/react/rsc";
import { AlertBanner, Markdown, type AlertStatus } from "@wojo/ui";
import React from "react";
import { useTourPageContext } from "../../_client/context";
import { MarketingTextCard } from "../marketing-text-card";
import styles from "./MessageTextCard.module.scss";

type MarketingTextCardsProps = {
    cards: SbBlokData[];
};

export const MessageTextCard: React.FC<MarketingTextCardsProps> = ({
    cards = [],
}) => {
    const { primaryMessageBody, primaryMessageStatus, primaryMessageTitle } =
        useTourPageContext();
    const title = primaryMessageTitle ?? "";
    const message = primaryMessageBody;
    const status = primaryMessageStatus || "alert";
    const hasOverrideMessage = !!title || !!message;
    const hasMarketingCard = !!cards.length;

    if (!hasOverrideMessage && !hasMarketingCard) {
        return null;
    }

    return hasOverrideMessage ? (
        <AlertBanner
            status={status as AlertStatus}
            title={title}
            style={{
                marginTop: "var(--g-spacing-xl)",
                marginBottom: "var(--g-spacing-xl)",
            }}
        >
            {!!message && (
                <Markdown
                    markdown={message}
                    markdownColor="inherit"
                    className={styles.message}
                />
            )}
        </AlertBanner>
    ) : (
        <MarketingTextCard cards={cards} primaryCard />
    );
};
